
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree9d4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree9d4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kuhCp", function(module, exports) {
// ヘッダー背景の切り替え
function $afd253655820fc86$var$onScroll() {
    const header = document.querySelector('#js-header') || document.querySelector('#js-header-top');
    const scroll = window.pageYOffset;
    if (header) {
        if (scroll > 200) header.classList.add('is-scroll');
        else header.classList.remove('is-scroll');
    }
}
window.addEventListener('scroll', $afd253655820fc86$var$onScroll);

});

parcelRegister("6PNqZ", function(module, exports) {
const $fe36f4fa1ee9b979$var$HEADER_OPEN_CLASS = 'is-open';
function $fe36f4fa1ee9b979$var$initTopMenu({ header: header, toggle: toggle, nav: nav }) {
    const matchMedia = window.matchMedia('(min-width: 768px)');
    /**
   * ナビゲーション要素のアクセシビリティ属性を設定
   * デスクトップサイズでは常にアクセス可能、モバイルではメニューの開閉状態に応じて制御
   * @param isOpen メニューが開いているかどうか
   */ function setNavAttributes(isOpen) {
        if (matchMedia.matches) {
            // PC表示時はダイアログ関連の属性を削除
            nav.removeAttribute('role');
            nav.removeAttribute('aria-modal');
            nav.removeAttribute('tabindex');
            nav.removeAttribute('inert');
            nav.removeAttribute('aria-hidden');
        } else {
            // モバイル表示時はダイアログとして機能
            nav.setAttribute('role', 'dialog');
            nav.setAttribute('aria-modal', 'true');
            nav.setAttribute('tabindex', '-1');
            nav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
            if (isOpen) nav.removeAttribute('inert');
            else nav.setAttribute('inert', '');
        }
    }
    /**
   * トグルボタンのアクセシビリティ属性を設定
   * @param isOpen メニューが開いているかどうか
   */ function setToggleAttributes(isOpen) {
        toggle.setAttribute('aria-label', isOpen ? "\u30E1\u30CB\u30E5\u30FC\u3092\u9589\u3058\u308B" : "\u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F");
    }
    /**
   * メニュー開閉時に他の要素の inert 属性を切り替え
   * メニューが開いている間は背景要素をフォーカス不可にする
   * @param isMenuOpen メニューが開いているかどうか
   * @see https://developer.mozilla.org/ja/docs/Web/API/HTMLElement/inert
   */ function toggleInertElements(isMenuOpen) {
        document.querySelectorAll('[data-header-inert-target="true"]').forEach((target)=>{
            if (isMenuOpen) target.setAttribute('inert', '');
            else target.removeAttribute('inert');
        });
    }
    /**
   * メニューの初期状態を設定
   * ページ読み込み時やブレイクポイント変更時に呼び出される
   */ function initMenuState() {
        setToggleAttributes(false);
        setNavAttributes(false);
        toggleInertElements(false);
    }
    /**
   * メニューを閉じた状態にリセット
   * ブレイクポイント変更時に呼び出される
   */ function resetMenuState() {
        header.classList.remove($fe36f4fa1ee9b979$var$HEADER_OPEN_CLASS);
        toggle.classList.remove($fe36f4fa1ee9b979$var$HEADER_OPEN_CLASS);
        initMenuState();
    }
    /**
   * モバイル時のメニュー状態を更新
   * メニューの開閉に応じてアクセシビリティ属性を一括更新
   * @param isOpen メニューが開いているかどうか
   */ function updateMobileMenuState(isOpen) {
        setToggleAttributes(isOpen);
        setNavAttributes(isOpen);
        toggleInertElements(isOpen);
    }
    /**
   * メニューを閉じる
   */ function closeMenu() {
        header.classList.remove($fe36f4fa1ee9b979$var$HEADER_OPEN_CLASS);
        toggle.classList.remove($fe36f4fa1ee9b979$var$HEADER_OPEN_CLASS);
        updateMobileMenuState(false);
    }
    /**
   * メニュー表示状態を切り替え
   * CSSクラスの切り替えとアクセシビリティ属性の更新を行う
   */ function toggleState() {
        header.classList.toggle($fe36f4fa1ee9b979$var$HEADER_OPEN_CLASS);
        toggle.classList.toggle($fe36f4fa1ee9b979$var$HEADER_OPEN_CLASS);
        const isOpen = header.classList.contains($fe36f4fa1ee9b979$var$HEADER_OPEN_CLASS);
        updateMobileMenuState(isOpen);
        // ダイアログが開いた時にフォーカスを移動
        if (isOpen) nav.focus();
    }
    matchMedia.addEventListener('change', resetMenuState);
    toggle.addEventListener('click', function() {
        if (matchMedia.matches) return;
        toggleState();
    });
    // ESCキーでダイアログを閉じる
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && header.classList.contains($fe36f4fa1ee9b979$var$HEADER_OPEN_CLASS)) closeMenu();
    });
    initMenuState();
}
// ハンバーガーメニュー
function $fe36f4fa1ee9b979$var$addMenuToggleEvent() {
    const header = document.querySelector('#js-header');
    const headerTop = document.querySelector('#js-header-top');
    const headerTopNav = document.querySelector('#top-header-nav');
    const toggle = document.querySelector('#js-toggle');
    if (header && toggle) toggle.addEventListener('click', function() {
        header.classList.toggle($fe36f4fa1ee9b979$var$HEADER_OPEN_CLASS);
        toggle.classList.toggle($fe36f4fa1ee9b979$var$HEADER_OPEN_CLASS);
    });
    else if (headerTop && toggle && headerTopNav) $fe36f4fa1ee9b979$var$initTopMenu({
        header: headerTop,
        toggle: toggle,
        nav: headerTopNav
    });
}
window.addEventListener('DOMContentLoaded', $fe36f4fa1ee9b979$var$addMenuToggleEvent);

});

parcelRegister("aTDgg", function(module, exports) {
// フッター アコーディオンメニュー
function $259742c81fa23a30$var$addMenuAcdEvent() {
    const acd = document.querySelectorAll('.js-acd');
    const openClass = 'is-open';
    if (acd) acd.forEach(function(value) {
        value.addEventListener('click', function() {
            if (window.matchMedia('(max-width: 768px)').matches) value.classList.toggle(openClass);
        });
    });
}
window.addEventListener('DOMContentLoaded', $259742c81fa23a30$var$addMenuAcdEvent);

});

parcelRequire("kuhCp");
parcelRequire("6PNqZ");
parcelRequire("aTDgg");


//# sourceMappingURL=clinic.6f7687db.js.map
